
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    root: {
        width: '100%',
        height: '100%',
    },

    container: {
        backgroundColor: '#ffffff',
        boxShadow: '0px 0px 8px rgb(0, 0, 0, 0.5)',
    }
})

const MapView = ({
    componentMap
}) => {

    return (
        <Stack verticalFill className={classNames.root}>
            <Stack.Item grow className={classNames.container}>
                <Stack className={classNames.root}>
                    <Stack.Item grow>
                        <div style={{display: 'flex', width:'100%', height:'100%'}}>{componentMap}</div>
                    </Stack.Item>
                </Stack>
            </Stack.Item>
        </Stack>
    )
}

export default MapView;
